export const DrumIcon = ({ className }: { className?: string }) => {
  return (
    <svg
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.9 6H20.1C20.5971 6 21 6.43561 21 6.97297C21 7.05696 21 7.45946 21 7.45946V17.1351C21 17.9891 20.6361 18.7294 20.1154 19.3208C19.5992 19.9072 18.8947 20.3911 18.0931 20.7762C16.4875 21.5477 14.3325 22 12 22C9.63453 22 7.46429 21.4126 5.85647 20.5067C5.05334 20.0542 4.35989 19.5047 3.85645 18.8768C3.35453 18.2508 3 17.491 3 16.6486V6.97297C3 6.43561 3.40294 6 3.9 6ZM4.8 7.94595V16.6486C4.8 16.881 4.89878 17.2059 5.21662 17.6023C5.53295 17.9968 6.02572 18.4077 6.6884 18.7811C8.0122 19.527 9.89196 20.0541 12 20.0541C14.141 20.0541 16.036 19.6352 17.362 18.998C18.0262 18.6789 18.508 18.3241 18.8115 17.9793C19.1106 17.6395 19.2 17.3559 19.2 17.1351V7.94595H4.8Z"
        fill="#1E1E1E"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.9 6H20.1C20.5971 6 21 6.43561 21 6.97297C21 7.05696 21 7.45946 21 7.45946V17.1351C21 17.9891 20.6361 18.7294 20.1154 19.3208C19.5992 19.9072 18.8947 20.3911 18.0931 20.7762C16.4875 21.5477 14.3325 22 12 22C9.63453 22 7.46429 21.4126 5.85647 20.5067C5.05334 20.0542 4.35989 19.5047 3.85645 18.8768C3.35453 18.2508 3 17.491 3 16.6486V6.97297C3 6.43561 3.40294 6 3.9 6ZM4.8 7.94595V16.6486C4.8 16.881 4.89878 17.2059 5.21662 17.6023C5.53295 17.9968 6.02572 18.4077 6.6884 18.7811C8.0122 19.527 9.89196 20.0541 12 20.0541C14.141 20.0541 16.036 19.6352 17.362 18.998C18.0262 18.6789 18.508 18.3241 18.8115 17.9793C19.1106 17.6395 19.2 17.3559 19.2 17.1351V7.94595H4.8Z"
        fill="black"
        fillOpacity="0.2"
      />
      <path
        d="M12 3C14.348 3 16.424 3.53119 17.8779 4.33887C19.3657 5.16542 20 6.14736 20 7C20 7.85264 19.3657 8.83458 17.8779 9.66113C16.424 10.4688 14.348 11 12 11C9.65205 11 7.57599 10.4688 6.12207 9.66113C4.63427 8.83458 4 7.85264 4 7C4 6.14736 4.63427 5.16542 6.12207 4.33887C7.57599 3.53119 9.65205 3 12 3Z"
        fill="#C2C2C2"
      />
      <path
        d="M12 3C14.348 3 16.424 3.53119 17.8779 4.33887C19.3657 5.16542 20 6.14736 20 7C20 7.85264 19.3657 8.83458 17.8779 9.66113C16.424 10.4688 14.348 11 12 11C9.65205 11 7.57599 10.4688 6.12207 9.66113C4.63427 8.83458 4 7.85264 4 7C4 6.14736 4.63427 5.16542 6.12207 4.33887C7.57599 3.53119 9.65205 3 12 3Z"
        stroke="#1E1E1E"
        strokeWidth="2"
      />
      <path
        d="M12 3C14.348 3 16.424 3.53119 17.8779 4.33887C19.3657 5.16542 20 6.14736 20 7C20 7.85264 19.3657 8.83458 17.8779 9.66113C16.424 10.4688 14.348 11 12 11C9.65205 11 7.57599 10.4688 6.12207 9.66113C4.63427 8.83458 4 7.85264 4 7C4 6.14736 4.63427 5.16542 6.12207 4.33887C7.57599 3.53119 9.65205 3 12 3Z"
        stroke="black"
        strokeOpacity="0.2"
        strokeWidth="2"
      />
    </svg>
  )
}
